import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { filterOutRequestExtraParameters, handleApiRequestSuccessData, handleRequestError } from '@jove-frontend/uikit';
import { isArray } from 'lodash';
import qs from 'qs';
import { api } from '../index';
export var apiQueryBrokerProductTradeList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var _res$data, _res$data$data, res;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get("/promotions/".concat(payload === null || payload === void 0 ? void 0 : payload.id, "/business_activities?").concat(qs.stringify(filterOutRequestExtraParameters(payload))));

          case 3:
            res = _context.sent;
            handleApiRequestSuccessData(res);

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.data)) {
              res.data.data.data = res.data.data.data.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  label: item.name,
                  value: item.code
                });
              });
            }

            return _context.abrupt("return", [res.data]);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function apiQueryBrokerProductTradeList(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiBatchCreateBrokerProductTrade = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.post("/promotions/".concat(payload === null || payload === void 0 ? void 0 : payload.id, "/business_activities/batch"), payload);

          case 3:
            res = _context2.sent;
            handleApiRequestSuccessData(res);
            return _context2.abrupt("return", [res.data]);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function apiBatchCreateBrokerProductTrade(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiUpdateBrokerProductTrade = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var params, res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            params = filterOutRequestExtraParameters(payload);
            delete params.id;
            delete params.activityId;
            _context3.next = 6;
            return api.patch("/promotions/".concat(payload === null || payload === void 0 ? void 0 : payload.id, "/business_activities/").concat(payload === null || payload === void 0 ? void 0 : payload.activityId), params);

          case 6:
            res = _context3.sent;
            handleApiRequestSuccessData(res);
            return _context3.abrupt("return", [res.data]);

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0));

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 11]]);
  }));

  return function apiUpdateBrokerProductTrade(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiDeleteBrokerProductTrade = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api["delete"]("/promotions/".concat(payload === null || payload === void 0 ? void 0 : payload.id, "/business_activities/").concat(payload === null || payload === void 0 ? void 0 : payload.activityId));

          case 3:
            res = _context4.sent;
            handleApiRequestSuccessData(res);
            return _context4.abrupt("return", [res.data]);

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0));

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 8]]);
  }));

  return function apiDeleteBrokerProductTrade(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiQueryBrokerProductRecommendedTradeList = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.get("/promotions/".concat(payload === null || payload === void 0 ? void 0 : payload.id, "/favourite_activities?").concat(qs.stringify(payload)));

          case 3:
            res = _context5.sent;
            handleApiRequestSuccessData(res);
            return _context5.abrupt("return", [res.data]);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0));

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 8]]);
  }));

  return function apiQueryBrokerProductRecommendedTradeList(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiAddBrokerProductRecommendedTrade = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.post("/promotions/".concat(payload === null || payload === void 0 ? void 0 : payload.id, "/favourite_activities"), payload);

          case 3:
            res = _context6.sent;
            handleApiRequestSuccessData(res);
            return _context6.abrupt("return", [res.data]);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", handleRequestError(_context6.t0));

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 8]]);
  }));

  return function apiAddBrokerProductRecommendedTrade(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export var apiDeleteBrokerProductRecommendedTrade = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return api["delete"]("/promotions/".concat(payload === null || payload === void 0 ? void 0 : payload.id, "/favourite_activities/").concat(payload === null || payload === void 0 ? void 0 : payload.activityId));

          case 3:
            res = _context7.sent;
            handleApiRequestSuccessData(res);
            return _context7.abrupt("return", [res.data]);

          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", handleRequestError(_context7.t0));

          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 8]]);
  }));

  return function apiDeleteBrokerProductRecommendedTrade(_x7) {
    return _ref7.apply(this, arguments);
  };
}();